<div class="filter-button" [ngClass]="{'filter-on': managersFilter || statusesFilter || customersFilter}">
  <button mat-button (click)="filterOp.toggle($event)">
    <mat-icon>filter_list</mat-icon>
  </button>
  <!-- <div class="types-info" *ngIf="filterIsOn">{{countTypes}} types</div> -->
</div>

<p-overlayPanel #filterOp [dismissable]="true" styleClass="board-filter-button">
  <div class="filters-block">
    <app-managers-filter class="managers fillter" (filterOn)="updateManagers($event)"></app-managers-filter>
    <app-customers-filter class="customers fillter" (filterOn)="updateCustomers($event)"></app-customers-filter>
    <app-payment-status-filter class="pStatuses fillter" (filterOn)="updateStatuses($event)">
    </app-payment-status-filter>
  </div>

</p-overlayPanel>
